<!-- #################################################################################### -->
<!-- ###### HERINCO                                                                ###### -->
<!-- ###### @author: Oscar Andrés Ochoa Villegas                                   ###### -->
<!-- ###### @date: Enero 2022                                                      ###### -->
<!-- #################################################################################### -->

<!-- #################################################################################### -->
<!-- ###### Sección de HTML                                                        ###### -->
<!-- #################################################################################### -->
<template>
  <v-layout>
      <v-card width="100%">
        <v-card-title>AYUDA</v-card-title>
        <v-card-text>
          <v-list-item>
            <v-list-item-content >
              <v-list-item-subtitle>Contenidos de ayuda para los usuarios del sistema</v-list-item-subtitle>
              <div><br/>
                <p class="customVerticalSapce">
                  <ul>
                    <li>Módulo de Configuración.</li>
                    <li>Módulo de Dispensación.</li>
                  </ul>
                </p>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
      </v-card>
  </v-layout>
</template>


<!-- #################################################################################### -->
<!-- ###### Sección de Scripts                                                     ###### -->
<!-- #################################################################################### -->
<script>
export default {
  name: 'help',
}
</script>

<!-- #################################################################################### -->
<!-- ###### Sección de Estilos                                                     ###### -->
<!-- #################################################################################### -->
<style scoped>
  .customVerticalSapce {
    line-height: 1.3;
  }
</style>